import edit from 'reducers/user/edit';
import list from 'reducers/user/list';
import { combineReducers } from 'redux-immutable';

export default combineReducers({ list, edit });
